














































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";
//@ts-ignore
import { Bar } from 'vue-chartjs'
//@ts-ignore
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
import VueHtml2pdf from "vue-html2pdf";
import bootstrap from "!raw-loader!./bootstrap.css";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import VueAxios from "vue-axios";
import axios from "axios";


//@ts-ignore
import reportes from '@/mixins/axios/reportes'

//@ts-ignore
import poa_series from '@/mixins/axios/poa_series'



@Component({
  components: {OrganizationChart,
  Bar,Line
  },
 props: ['options'],
  data() {
    return {
      color:'#005aff',
      color1:'#1332a0',
      color2:'#1f7ad8',
      color3:'#0013ff',
      programa:0,
      secretaria:0,
      serie:0,
      programas:[],
      secretarias:[],
      series:[],
      count:0,
      myChart:null,
      myChart2:null,
      data:[],
 /*data:[{"nombre":"CAPITAL HUMANO","id":9,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"departamentos":
 [
   {"nombre":"RECURSOS HUMANOS","id":12,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"poas":[{"nombre":"SEGURIDAD PUBLICA TORREON","id":12,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"financiero_e":[0,0,0,0],"financiero_a":[0,0,0,0],"lineas":[{"nombre":"Incidencia delictiva","id":27,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"actividades":[{"nombre":"AUMENTO DE CUERPO MILITAR","fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5]}]},{"nombre":"Insuficientes elementos operativos de policia","id":28,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]},{"nombre":"Descomposici\u00f3n del tejido social","id":29,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]}]}]},
    {"nombre":"RECURSOS HUMANOS","id":12,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"poas":[{"nombre":"SEGURIDAD PUBLICA TORREON","id":12,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"financiero_e":[0,0,0,0],"financiero_a":[0,0,0,0],"lineas":[{"nombre":"Incidencia delictiva","id":27,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"actividades":[{"nombre":"AUMENTO DE CUERPO MILITAR","fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5]}]},{"nombre":"Insuficientes elementos operativos de policia","id":28,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]},{"nombre":"Descomposici\u00f3n del tejido social","id":29,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]}]}]}
 ]}]
*/
    };
  },
  mixins: [
 reactiveProp,reportes,poa_series
  ],
  methods: {
 onChangeSerie(event){

  let data= this.series.filter(item => item.id ==event.target.value )

  console.log(data,'---------poas----')
 this.secretarias=data[0].secretarias;
 this.programas=[];
 this.secretaria=0;
 this.programa=0;
//aqui cargarle los secretarias dependiendo de la serie no necesitas cargar om hacer una peticion porque ya la tienes en las series vienen toda la info

 },
 onChangeSecretaria(event){

  let data= this.secretarias.filter(item => item.id ==event.target.value )

  console.log(data)
 this.programas=data[0].poas;
 this.programa=0;
//aqui cargarle los secretarias dependiendo de la serie no necesitas cargar om hacer una peticion porque ya la tienes en las series vienen toda la info

 },
async getSeries(){
  console.log('series')
   this.$root.$emit('loading', true);



let data= await this.GET_POA_SERIES_FILTER().then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.series=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
async getData(){
//
 this.show=false;
this.$root.$emit('loading', true);

if(this.serie==0){
 this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar datos, Es necesario seleccionar almenos una serie");

}



let row={
  serie:this.serie,
  secretaria:this.secretaria,
  programa:this.programa

}
let data= await this.getReporteTrimestre(row).then(response => {

                    if (response != null) {
                
                      this.data=response;
                      //this.parseDataAvanceFisico(this.data,'Avance Fisico');
                      //this.parseDataAvanceFinanciero(this.data,'Avance Financiero');
                      this.grafica3();
  
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar datos, refresque la pagina");

                    }
                      this.$root.$emit('loading', false);
                });
},

    formatNumberAcumulado(aplicado,esperado,trimestre){
let suma=Number(esperado[0])+Number(esperado[1])+Number(esperado[2])+Number(esperado[3]);
let sum2=Number(aplicado[0])+Number(aplicado[1])+Number(aplicado[2])+Number(aplicado[3]);

let trimestral=suma/4;

      switch (trimestre) {
        case 1:
          if(aplicado[0]==0){
            return 0+'%';
          }
          return ((aplicado[0]/trimestral)*100)+'%';
          break;
          
          case 2:
          if((aplicado[1]+aplicado[0])==0){
             return 0+'%';
          }
           return (((aplicado[1]+aplicado[0])/(suma))*100)+'%';
          break;
          case 3:
          if((aplicado[1]+aplicado[0]+aplicado[2])==0){
             return 0+'%';
          }
           return (((aplicado[1]+aplicado[0]+aplicado[2])/(suma))*100)+'%';
          break;
          case 4:
          if((aplicado[1]+aplicado[0]+aplicado[2]+aplicado[3])==0){
             return 0+'%';
          }
           return (((aplicado[1]+aplicado[0]+aplicado[2]+aplicado[3])/(suma))*100)+'%';
          break;
      
        default:
          break;
      }


    },
     PrintImage() {
   
    
     var link = document.createElement('a');
  link.download = 'filename.png';
  link.href = document.getElementById('myChart').toDataURL()
  link.click();

},


     
      formatDataFinanciero2(){
        var data_col=[];
         var data_col1=[];
         var data_col2=[];
         var data_col3=[];
           var data_grl=[];
        //console.log(data)
         let th=this;
           this.data.forEach((valD, indexD) =>{
              if(valD.hasOwnProperty('departamentos')){
                    valD['departamentos'].forEach((val2, index2) =>{
                        if(val2.hasOwnProperty('poas')){
                              val2['poas'].forEach((val, index) =>{
                                  data_col.push({x:val.financiero_e[0],y:val.financiero_a[0]})
                                     data_col1.push({x:val.financiero_e[1],y:val.financiero_a[1]})
                                        data_col2.push({x:val.financiero_e[2],y:val.financiero_a[2]})
                                           data_col3.push({x:val.financiero_e[3],y:val.financiero_a[3]})
                                  //data_col2.push(val.financiero_a)
                              })
                        }
                    });
              }
        });
          
       
           
          
        return [data_col,data_col1,data_col2,data_col3];

      },



grafica3(){
  if(this.count>0){
    this.myChart.destroy();
  }
        var ctx = document.getElementById("myChart3").getContext('2d');
  var data = this.formatDataFinanciero2()
         // Add data values to array
// End Defining data
var options = {responsive: true,
 // Instruct chart js to respond nicely.
    maintainAspectRatio: false,
     plugins: {
        tooltip: {
            callbacks: {
                label: function(ctx) {
                    // console.log(ctx);
                    let label = ctx.dataset.labels[ctx.dataIndex];
                    label += " (" + ctx.parsed.x + ", " + ctx.parsed.y + ")";
                    return label;
                }
            }
        }
    } // Add to prevent default behaviour of full-width/height 
};

// End Defining data
 this.myChart = new Chart(ctx, {
    type: 'scatter',
    data: {
        datasets: [{
                label: '1# Trimestre', // Name the series
                 labels: this.formatLabelsFisico(data),
                data: data[0], // Specify the data values array
          borderColor: '#2196f3', // Add custom color border     
                backgroundColor:'#00ff73'  
         
        },{
                label: '2# Trimestre', // Name the series
                 labels: this.formatLabelsFisico(data),
                data: data[1], // Specify the data values array
          borderColor: '#2196f3', // Add custom color border 
          backgroundColor:'#ff0000'    
                
         
        },
        {
                label: '3# Trimestre', // Name the series
                 labels: this.formatLabelsFisico(data),
                data: data[2], // Specify the data values array
          borderColor: '#2196f3', // Add custom color border     
                backgroundColor:'#2109d8'  
         
        },
        {
                label: '4# Trimestre', // Name the series
                 labels: this.formatLabelsFisico(data),
                data: data[3], // Specify the data values array
          borderColor: '#2196f3', // Add custom color border     
                backgroundColor:'#eeff00'  
         
        },/*{
                label: 'Population2', // Name the series
                data: data2, // Specify the data values array
          borderColor: '#6ff3f3', // Add custom color border            
          backgroundColor: '#6ff3f3', // Add custom color background (Points and Fill)
            }*/]
    },
    options: options
});
this.count=this.count+1;
},


 PrintImage2() {
    var link = document.createElement('a');
  link.download = 'filename.png';
  link.href = document.getElementById('myChart2').toDataURL()
  link.click();

},
    formatNumberP(num1,num2){
      if(num1==0){
return '0%';
      }else{
return (((num1/num2)*100)>100)?'100':((num1/num2)*100)+'';
      }



      
    },
    formatNumber(num1,num2){
      if(num1==0){
return '0%';
      }else{
return (((num1/num2)*100)>100)?'100%':((num1/num2)*100)+'%';
      }



      
    }
  ,
   getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
},
//inicio data fisico--------------------------------------------------
      fillDataFisico(data){
        //console.log('=--------------set--2---------------')
        this.datacollection = {
          labels: this.formatLabelsFisico(data),
          datasets: this.formatDataFisico(data)
        }
       return this.datacollection;
        //this.renderChart(this.datacollection, this.options)
      },
      formatLabelsFisico(data){
       // console.log('=--------------set-3----------------')
         var data_labels=[];
         // console.log(data,'=--------------set-4----------------')
           data.forEach((valD, indexD) =>{
           //  console.log(valD,'=--------------set-5----------------')
               if(valD.hasOwnProperty('departamentos')){
                  valD['departamentos'].forEach((val2, index2) =>{
                      //  console.log(val2,'=--------------set-6----------------')

                        if(val2.hasOwnProperty('poas')){
                            val2['poas'].forEach((val, index) =>{
                                data_labels.push(val.nombre)
                            })
                        }
                    
                      })
               }







        })
        return data_labels;
      },
      formatDataFisico(data){
        var data_col=[];
         var data_col2=[];
          var data_col3=[];
           var data_col4=[];
           var data_grl=[];
        console.log(data)
         let th=this;
           data.forEach((valD, indexD) =>{
          if(valD.hasOwnProperty('departamentos')){
                    valD['departamentos'].forEach((val2, index2) =>{
                        if(val2.hasOwnProperty('poas')){
                              val2['poas'].forEach((val, index) =>{


                               console.log(this.formatNumberP(val.fisico_a[1],val.fisico_e[1]))
                                    data_col.push(this.formatNumberP(val.fisico_a[0],val.fisico_e[0]))
                                    data_col2.push(this.formatNumberP(val.fisico_a[1],val.fisico_e[1]))
                                    data_col3.push(this.formatNumberP(val.fisico_a[2],val.fisico_e[2]))
                                    data_col4.push(this.formatNumberP(val.fisico_a[3],val.fisico_e[3]))
                              })
                        }
                    });
          }
        });


          
          data_grl.push({
              label: ['Trimestre #1'],
              backgroundColor: this.color,
              data: data_col
            })
            data_grl.push({
              label: ['Trimestre #2'],
              backgroundColor: this.color1,
             data: data_col2
            })
            data_grl.push({
              label: ['Trimestre #3'],
              backgroundColor: this.color2,
              data: data_col3
            })
            data_grl.push({
              label: ['Trimestre #4'],
              backgroundColor: this.color3,
               data: data_col4
            })
          
        return data_grl;

      },
      parseDataAvanceFisico(data,texto){

console.log('=--------------set-----------------')
            var ctx = document.getElementById("myChart").getContext('2d');
            if(this.myChart!=null){
              this.myChart.destroy();
              this.myChart=null;
            }
            this.myChart = new Chart(ctx, {
              type: 'bar',
              data:  this.fillDataFisico(data),
              options: {
                indexAxis: 'x',
              
                elements: {
                  bar: {
                    borderWidth: 2,
                  }
                },
                responsive: true,
                plugins: {
                  legend: {
                    position: 'top',
                  },
                  title: {
                    display: true,
                    text: texto
                  }
                },
              
                onClick: function (point, event) {
                  const item = event

                  console.log( point)
                  
                }
        },


          
          onClick:function(e){
            console.log(e)
          var activePoints = myChart.getElementsAtEvent(e);
          var selectedIndex = activePoints[0]._index; 
          console.log(selectedIndex,'------t------')
        
          }
});
      },


    




      //end grafica fisico----------------------------------------
      parseDataAvanceFinanciero(data,texto){


            var ctx = document.getElementById("myChart2").getContext('2d');
            if(this.myChart2!=null){
              this.myChart2.destroy();
              this.myChart2=null;
            }
            this.myChart2 = new Chart(ctx, {
              type: 'bar',
              data:  this.fillDataFinanciero(data),
              options: {
                indexAxis: 'x',
              
                elements: {
                  bar: {
                    borderWidth: 2,
                  }
                },
                responsive: true,
                plugins: {
                  legend: {
                    position: 'top',
                  },
                  title: {
                    display: true,
                    text: texto
                  }
                },
              
                onClick: function (point, event) {
                  const item = event

                  console.log( point)
                  
                }
        },


          
          onClick:function(e){
            console.log(e)
          var activePoints = myChart.getElementsAtEvent(e);
          var selectedIndex = activePoints[0]._index; 
          console.log(selectedIndex,'------t------')
        
          }
});
      },
 fillDataFinanciero(data){
        this.datacollection = {
          labels: this.formatLabelsFisico(data),
          datasets: this.formatDataFinanciero(data)
        }
       return this.datacollection;
        //this.renderChart(this.datacollection, this.options)
      },
     
      formatDataFinanciero(data){
        var data_col=[];
         var data_col2=[];
           var data_grl=[];
        console.log(data)
         let th=this;
           data.forEach((valD, indexD) =>{
              if(valD.hasOwnProperty('departamentos')){
                    valD['departamentos'].forEach((val2, index2) =>{
                        if(val2.hasOwnProperty('poas')){
                              val2['poas'].forEach((val, index) =>{
                                  data_col.push(val.financiero_e)
                                  data_col2.push(val.financiero_a)
                              })
                        }
                    });
              }
        });
          
          data_grl.push({
              label: ['Planeado'],
              backgroundColor: th.getRandomColor(),
              data: data_col
            })
            data_grl.push({
              label: ['Ejercido'],
              backgroundColor: th.getRandomColor(),
             data: data_col2
            })
           
          
        return data_grl;

      },






  },
  created() {},

  mounted() {
   this.getSeries();
   
   //this.parseDataAvanceFisico(this.data,'Avance Fisico');
     //                 this.parseDataAvanceFinanciero(this.data,'Avance Financiero');
/*
    this.renderChart(data, options)
   this.renderChart(this.chartData, this.options)
*/
  },
})
export default class Home extends Vue {

  // @Prop() private id !:any;
}
